module.exports = __webpack_public_path__ + "static/media/PMG_Security_Features.8d332a65.pdf";